export default __webpack_public_path__ + "media/alarm_single_ring.8e67ebf.mp3";